import * as React from 'react';
import * as I18nAPI from '../api/i18n';
import { DebugMode } from '../contexts';
export function i18nLeague({ sport, region, league }, debug) {
    const translation = I18nAPI.translate('leagues', `${sport}-${region}-${league}`);
    if (debug) {
        return league + (translation ? '*' : '');
    }
    return translation || league;
}
const League = props => {
    const debugEnabled = React.useContext(DebugMode);
    return React.createElement(React.Fragment, null, i18nLeague(props, debugEnabled));
};
export default League;
//# sourceMappingURL=League.js.map